module.exports = __webpack_public_path__ + "media/zapsplat_multimedia_correct_tone_beep_17736.591b4fdc.mp3";